/*
 * @Author: your name
 * @Date: 2021-07-23 10:04:02
 * @LastEditTime: 2021-08-20 14:30:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dc-vietnam-website-front\src\i18n\lang\zhVietnamese.js
 */
module.exports = {
    message: {
        title_Tip:"Hoàn tất đăng ký trước nhận thông tin OB", 
        email_label:"Hòm thư" ,
        birth_label:"Sinh nhật",
        phone_label:"HĐH điện thoại",
        email_dec:"Địa chỉ email",
        protocol:"Đánh dấu vào đấy có nghĩa đã đồng ý nhận email định kỳ của game 《Chân Mệnh Thiên Tử Mobile》, ví dụ thông tin mới nhất, khuyến mãi và phiếu điều tra.",
        problem_tip:"Nếu có bất cứ thắc mắc nào, vui lòng tư vấn",
        concact_email:"cs@clicktouch.cc",
        Android:"ANDROID",
        ios:"IOS",
        reward_tip:"Người chơi đăng ký trước thành công sẽ nhận được một phần thưởng giá trị khi game bắt đầu open beta.",
        getreward_tip:"(Hãy nhận thông tin qua thư sau khi game ra mắt)",
        num_tip:"Người đã đăng ký trước",
        num:"người",
        appoint_success:"Bạn đã đăng ký trước thành công!",
        appoint_fail:"Đăng ký trước thất bại, vui lòng làm lại!",
        email_error:"Định dạng email sai, vui lòng điền lại!",
        email_null:"Email không thể để trống!",
        phone_type:"Vui lòng chọn một loại điện thoại!",
        datetime:"Vui lòng chọn ngày sinh!",
        accept_tip:"Vui lòng đánh dấu vào thỏa thuận trò chơi!",
        Qualification:"Trái Tư Chất*1",
        money:"Ngân Phiếu*7",
        Soldier:"Binh Phù*3",
        Ingots:"Nguyên Bảo*100",
        Privacypolicy:"【ChínhSáchBảoMật】",
        notice:"Thông báo quan trọng:",
        UserAgreement:"【Thỏa thuận người dùng】"
    }
}